// App
// ----------------------
import React, { useEffect, } from 'react';
// routing
import { Routes, Route, } from "react-router-dom";
import { NoMatch } from './router-no-match.js'; // 404 - No Match
import { PrivateRouteAuthIhrWebSdk, OwnerVerifyRoute, } from './routes'; // custom routes

// authentication
// auth/ihr-web-sdk
import AuthWrapperIhrWebSdk from './features/auth/ihr-web-sdk/auth-wrapper/auth-wrapper';
// layouts
// Public
import PublicDefaultLayout from './layouts/public/default-layout/default-layout'; // Default Layout
// components
import Homepage from './features/public/homepage/homepage'; // public marketing homepage
// Private
import DashboardDefaultLayout from './layouts/private/dashboard/default/dashboard-default'; // layout - private dashboard
import DashboardHome from './features/dashboard/home/home'; // feature - private dashboard home
// npm
import TagManager from '@sooro-io/react-gtm-module'
// libraries
import 'semantic-ui-less/semantic.less';
// styles
//import './App.css'; //App level css import
//import './App.scss'; //App level scss import
//import stylesCss from './App-css-module.module.css'; //App level-scoped css import
//import stylesScss from './App-scss-module.module.scss'; //App level-scoped scss import

//const REACT_APP_ENV_MODE = process.env.REACT_APP_ENV_MODE;
//console.debug('REACT_APP_ENV_MODE', REACT_APP_ENV_MODE);
const REACT_APP_ANALYTICS_GTM = process.env.REACT_APP_ANALYTICS_GTM;
//console.debug('REACT_APP_ANALYTICS_GTM', REACT_APP_ANALYTICS_GTM);

function App() {

  useEffect(() => {
    if (REACT_APP_ANALYTICS_GTM) {
      const tagManagerArgs = {
        gtmId: REACT_APP_ANALYTICS_GTM,
      };
      TagManager.initialize(tagManagerArgs);
    }
  }, []);

  return (
    <div className="App">
      <AuthWrapperIhrWebSdk>
        <Routes>
          <Route path={'/*'} element={<PublicDefaultLayout component={Homepage} />} />
          <Route path={'/dashboard/'} element={<PrivateRouteAuthIhrWebSdk component={PublicDefaultLayout} redirectTo={'/'} />}>
            <Route index element={<DashboardDefaultLayout component={DashboardHome} />} />
          </Route>
          <Route path={'/verify/:submissionUUID'} element={<PublicDefaultLayout component={OwnerVerifyRoute} />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </AuthWrapperIhrWebSdk>
    </div>
  );
}

export default App;
